import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
interface MetaPixelProps {
  pixelId: string;
}
export function MetaPixel({
  pixelId
}: MetaPixelProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    // If pixel already initialized, just fire PageView
    if (window.fbq) {
      try {
        window.fbq('track', 'PageView');
      } catch (e) {
        // no-op
      }
      return;
    }
    // Initialize fbq stub
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    // Inject the Facebook events script safely
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const target = document.head || document.body || document.documentElement;
    if (target) {
      target.appendChild(script);
    }
    try {
      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');
    } catch (e) {
      // no-op
    }
  }, [pixelId]);
  return <noscript data-id="element-159">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} data-id="element-160" />
    </noscript>;
}